import styled from '@emotion/styled'

export const Wrapper = styled.div`
  display: flex;
  margin: 15px 0;
`
